import { Component } from '@angular/core';
import { GlobalConstants } from '../global-constants';
import { QueryService } from '../services/query.service';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrl: './login-register.component.css'
})
export class LoginRegisterComponent {
  formData: any = { username: '', password: '' };
  error: string = '';

  constructor(private query: QueryService, private loader: LoaderService) {}

  login() {
    this.loader.show();
    this.query.query('login', null, this.formData).subscribe((resultado:any) => {
      //this.busy = false;
      // Error
      if (resultado['resultado'] == 'ERROR') {
        this.error = resultado.mensaje;
        this.formData.password = '';
        this.loader.hide();
      // usuario bloqueado
      } else if (resultado['resultado'] == 'BLOCKED') {
        this.formData.password = '';
        this.error = resultado.mensaje;
        this.error += ' <a href="' + GlobalConstants.urlServer + '/password-remember" class="active-href">¿No recuerdas la constraseña?</a>';
        this.loader.hide();
      // OK
      } else {
        const token = resultado.token;
        localStorage.setItem('token', token); // Guardar el token en el almacenamiento local
        this.formData.password = '';
        this.formData.username = '';
        window.location.href = GlobalConstants.urlServer;
      }
    });
  }

}
